import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

interface FlightSearchStoreActions {
  setLastFlightResultsParams: (params: Record<string, unknown>) => void
}

interface FlightSearchStoreState {
  lastFlightResultsParams: null | Record<string, unknown>
}

export const useFlightSearchStore = create<FlightSearchStoreActions & FlightSearchStoreState>()(
  persist(
    (set) => ({
      lastFlightResultsParams: null,
      setLastFlightResultsParams: (params) => {
        set({ lastFlightResultsParams: params })
      },
    }),
    {
      name: 'flight-search',
      storage: createJSONStorage(() => localStorage),
    }
  )
)
